import { useState, useCallback, useEffect } from 'react';
import { api } from 'app/api/client';
import { IUploadSession } from '../types/Documents';

export const useUploadSession = (pathwayId: string) => {
  const [session, setSession] = useState<IUploadSession | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const createSession = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(false);
      setSession(null);
      const data = await api.post<IUploadSession>(
        `rpm/api/v1/pathways/${pathwayId}/documents/upload-session`,
      );
      setSession(data);
    } catch {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  }, [pathwayId]);

  useEffect(() => {
    createSession();
  }, [createSession]);

  return { session, isLoading, error, refresh: createSession };
};
